export default "__VITE_ASSET__v0_whzVW__"